import ProductContainerCategory from './ProductContainerCategory.jsx';

export default ProductContainerCategory;


// WEBPACK FOOTER //
// ./src/components/ProductContainerCategory/index.jsx